// ====== Config selectors (adjust to your theme) ======
var FORM_SELECTOR = '#product-grid form[action="/cart/add"]'; // or '.js-card-add-to-cart'
var PRODUCT_FORM_SELECTOR = 'product-form';                  // Dawn uses <product-form>

// (Optional) If you already have these helpers in your codebase, keep using them.
// If not, you can remove the updateSelectedVariant/findHiddenIdInput parts safely.
function findHiddenIdInput($pf) {
  return $pf.find('input[name="id"]').first();
}

// ====== AJAX Add to Cart (redirect with open_cart_n=2) ======
$(document).on('.quick-add.no-js-hidden submit.cardATC', FORM_SELECTOR, function (e) {
  var $form = $(this);

  // Prevent double submit
  if ($form.data('submitting')) {
    e.preventDefault();
    return;
  }

  e.preventDefault();

  var $pf = $form.closest(PRODUCT_FORM_SELECTOR);

  // If you have a function to sync selected variant -> hidden input, call it here
  // if ($pf.length) updateSelectedVariant($pf);

  var formEl = $form.get(0);
  if (!formEl) return;

  var formData = new FormData(formEl);
  var id = formData.get('id');

  // Fallback: ensure variant id exists (some themes store it elsewhere)
  if (!id && $pf.length) {
    var $hidden = findHiddenIdInput($pf);
    if ($hidden.length) id = $hidden.val();
    if (id) formData.set('id', id);
  }

  if (!id) return;

  $form.data('submitting', true);

  var $btn = $form.find('[type="submit"]').first();
  $btn.prop('disabled', true).addClass('loading');

  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',

    success: function () {
      // Build the same URL like your existing logic
      var url = new URL(window.location.href);
      url.searchParams.set('open_cart_n', '2');

      // Redirect (will reload page by design)
      window.location.href = url.toString();
    },

    error: function (xhr) {
      // Shopify often returns JSON with "description" when failing
      var msg = 'Add to cart failed';
      try {
        var res = JSON.parse(xhr.responseText);
        if (res && res.description) msg = res.description;
      } catch (err) {}
      console.error('ATC error:', xhr);
      alert(msg);
    },

    complete: function () {
      $form.data('submitting', false);
      $btn.prop('disabled', false).removeClass('loading');
    }
  });
});